/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { AttachPaperclipIcon16Light } from './AttachPaperclipIcon16Light';
import { AttachPaperclipIcon16Regular } from './AttachPaperclipIcon16Regular';
import { AttachPaperclipIcon16Solid } from './AttachPaperclipIcon16Solid';
import { AttachPaperclipIcon20Light } from './AttachPaperclipIcon20Light';
import { AttachPaperclipIcon20Regular } from './AttachPaperclipIcon20Regular';
import { AttachPaperclipIcon20Solid } from './AttachPaperclipIcon20Solid';
import { AttachPaperclipIcon24Regular } from './AttachPaperclipIcon24Regular';
import { AttachPaperclipIcon24Solid } from './AttachPaperclipIcon24Solid';
import { AttachPaperclipIcon32Regular } from './AttachPaperclipIcon32Regular';
import { AttachPaperclipIcon64Regular } from './AttachPaperclipIcon64Regular';
var sizes = {
    16: {
        light: AttachPaperclipIcon16Light,
        regular: AttachPaperclipIcon16Regular,
        solid: AttachPaperclipIcon16Solid,
    },
    20: {
        light: AttachPaperclipIcon20Light,
        regular: AttachPaperclipIcon20Regular,
        solid: AttachPaperclipIcon20Solid,
    },
    24: {
        regular: AttachPaperclipIcon24Regular,
        solid: AttachPaperclipIcon24Solid,
    },
    32: {
        regular: AttachPaperclipIcon32Regular,
    },
    64: {
        regular: AttachPaperclipIcon64Regular,
    },
};
export var AttachPaperclipIcon = forwardRef('AttachPaperclipIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
